import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { RadioGroupProps } from './RadioGroup';

import { RadioGroup } from './RadioGroup';

const codeString = `
  <RadioGroup label={label} options={options} 
    onChange={onChangeFunction} disabled={disabled} /> `;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Molecules/RadioGroup',
  component: RadioGroup,
  argTypes: {
    label: {
      control: 'text',
    },
    disabled: {
      control: 'boolean',
    },
  },
  parameters: {
    inspectComponent: RadioGroup,
    codeString: codeString,
  },
} as Meta<RadioGroupProps>;

const mockData = [
  {
    id: '1',
    titleLabel: 'Option 1',
    value: 'option1',
  },
  {
    id: '2',
    titleLabel: 'Option 2',
    value: 'option2',
  },
  {
    id: '3',
    titleLabel: 'Option 3',
    value: 'option3',
  },
];

const Template: StoryFn<RadioGroupProps> = (args) => <RadioGroup {...args} />;

export const RadioGroupExample = Template.bind({});
RadioGroupExample.args = {
  disabled: false,
  label: 'Sample label',
  options: mockData,
  onChange: fn(),
};
